import { render, staticRenderFns } from "./RouteSettingsPanel.vue?vue&type=template&id=486a0d0e"
import script from "./RouteSettingsPanel.vue?vue&type=script&lang=js"
export * from "./RouteSettingsPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports